import React, { useState, useRef, useEffect } from "react";
import "./edit.css";
import Veg from "../../../../Assets/veg.svg";
import NonVeg from "../../../../Assets/NonVeg.svg";
import cross from "../../../../Assets/cross.svg";
import { useToast } from "../../../../mesageToast/ToastContainer";
import api from "../../../../services/api";
import axios from "axios";

const EditModal = ({ isOpen, onClose, dishDetails, onSave, categoryList }) => {
  const [dishName, setDishName] = useState(dishDetails.dishId.dishName);
  const [category, setCategory] = useState(dishDetails.dishId.dishCatagory);
  const [isNewCategory, setIsNewCategory] = useState(false);
  const [addNewCategory, setAddNewCategory] = useState("");
  const [price, setPrice] = useState(dishDetails.resturantDishPrice);
  const [dishDescription, setDishDescription] = useState(dishDetails.dishId.dishDescription || "");
  const [images, setImages] = useState([]);
  const addToast = useToast();
  const [isVeg, setIsVeg] = useState(
    dishDetails.dishId.dishType === 0 ? true : false
  ); // Default to Veg
  const [error, setError] = useState({
    dishName: "",
    category: "",
    dishPrice: "",
    addNewCatageory: "",
    dishImage: "",
    dishDescription: "",
  });
  const fileInputRef = useRef(null);

  // Reset state when modal opens or dishDetails changes
  useEffect(() => {
    if (isOpen) {
      setDishName(dishDetails.dishId.dishName);
      setCategory(dishDetails.dishId.dishCatagory);
      setPrice(dishDetails.resturantDishPrice);
      setDishDescription(dishDetails.dishId.dishDescription || "");
      setIsVeg(dishDetails.dishId.dishType === 0);
      setImages(
        dishDetails.dishId.dishImageUrl?.map(url => {
          const key = url.split('?')[0].split('/').pop();
          return {
            preview: url,
            key: key,
            isExisting: true
          };
        }) || []
      );
      setIsNewCategory(false);
      setAddNewCategory("");
      setError({
        dishName: "",
        category: "",
        dishPrice: "",
        addNewCatageory: "",
        dishImage: "",
        dishDescription: "",
      });
    }
  }, [isOpen, dishDetails]);

  const handleVegToggle = (vegStatus) => {
    setIsVeg(vegStatus);
  };

  const uploadImageToS3 = async (file) => {
    try {
      const response = await api.get("/restaurant-management/menu/generatePresignedUrl", {
        params: {
          fileType: file.type,
          documentType: "dishImage",
          dishId: dishDetails._id,
        },
      });

      const { uploadUrl, key } = response.data;

      await axios.put(uploadUrl, file, {
        headers: {
          "Content-Type": file.type,
        },
      });

      return {
        preview: URL.createObjectURL(file), // for UI only
        key, // S3 key for storage
      };
    } catch (error) {
      console.error("Error uploading image:", error);
      addToast("Error", "Failed to upload image. Please try again.", "error");
      throw error;
    }
  };

  const handleImageUpload = async (event) => {
    const files = Array.from(event.target.files);

    // Validate exactly 1 image
    if (images.length + files.length > 1) {
      addToast("Error", "You can only upload 1 image.", "error");
      return;
    }

    // Filter files to ensure only image files are uploaded
    const validFiles = files.filter((file) => {
      if (file.type.startsWith("image/")) {
        if (file.size <= 5 * 1024 * 1024) {
          return true; // Valid image file within size limit
        } else {
          addToast("Error", `${file.name} exceeds the 5MB limit.`, "error");
          return false; // File size exceeds the limit
        }
      } else {
        addToast("Error", `${file.name} is not a valid image.`, "error");
        return false; // Not an image file
      }
    });

    try {
      const uploadPromises = validFiles.map(uploadImageToS3);
      const uploadedImages = await Promise.all(uploadPromises);
      setImages(uploadedImages); // Replace existing image
      setError((prevState) => ({ ...prevState, dishImage: "" }));
    } catch (error) {
      console.error("Error handling image upload:", error);
    }
  };

  const removeDishImagesFromS3 = async (s3Keys) => {
    try {
      await api.delete("/restaurant-management/removeDishImages", {
        data: { s3Keys }
      });
    } catch (error) {
      console.error("Error removing images from S3:", error);
    }
  };

  const handleRemoveImage = async (index) => {
    const imageToRemove = images[index];
    
    // Remove from S3 if it has a key and is not an existing image
    if (imageToRemove.key && !imageToRemove.isExisting) {
      await removeDishImagesFromS3([imageToRemove.key]);
    }
    
    URL.revokeObjectURL(imageToRemove.preview); // Clean up the object URL
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleClickAddImage = () => {
    fileInputRef.current.click(); // Trigger the hidden file input element
  };

  const handleCategoryChange = (e) => {  
    setAddNewCategory(e.target.value); // Allow all inputs 
    setError((prevState) => ({ ...prevState, addNewCatageory: "" }));   
  };  
    
  const handleCategoryKeyDown = (e) => {  
    setError((prevState) => ({ ...prevState, addNewCatageory: "" }));  
  };

  const handleSelectCategoryChange = (e) => {
    if (e.target.value === "Others") {
      setIsNewCategory(true);
      setCategory("Others");
      setError((prevState) => ({ ...prevState, addNewCatageory: "" })); // Clear category error on valid selection
    } else {
      setAddNewCategory("");
      setIsNewCategory(false);
      setCategory(e.target.value);
    }
  };

  const handleToggleCategory = () => {
    setIsNewCategory((prev) => !prev);
    if (isNewCategory) {
      setCategory(""); // Clear new category on close
    }
  };

  const handleDishNameChange = (e) => {
    setDishName(e.target.value); // Allow all inputs
    setError((prevState) => ({ ...prevState, dishName: "" }));   
  };

  const handleDishNameKeyDown = (e) => {
      setError((prevState) => ({ ...prevState, dishName: "" }));
  };

  const handleSetPriceChange = (e) => {
    const value = e.target.value;

    if (/[^0-9.]/.test(value)) {
      setError((prevState) => ({
        ...prevState,
        dishPrice: "Invalid Price",
      }));
      return;
    }
    const regex = /^\d{0,5}(\.\d{0,2})?$/;

    if (!regex.test(value)) {
      setError((prevState) => ({
        ...prevState,
        dishPrice: "Price must be up to 99999.99.",
      }));
    } else if (/^00/.test(value)) {
      setError((prevState) => ({
        ...prevState,
        dishPrice: "Price cannot start with consecutive zeros.",
      }));
    } else {
      setPrice(value);
      setError((prevState) => ({ ...prevState, dishPrice: "" }));
    }
  };

  const handleSave = (e) => {
    e.preventDefault();
    // Check if the details have been modified
    const isModified = 
    dishName !== dishDetails.dishId.dishName ||
    category !== dishDetails.dishId.dishCatagory ||
    price !== dishDetails.resturantDishPrice ||
    dishDescription !== (dishDetails.dishId.dishDescription || "") ||
    isVeg !== (dishDetails.dishId.dishType === 0) ||
    images.some(img => !img.isExisting) || // Check if any new images were added
    images.length !== (dishDetails.dishId.dishImageUrl?.length || 0); // Check if image count changed

  if (!isModified) {
    // Show toast message for no updates
    addToast(
      "No updates were made",
      `The Item details remain the same as the previous one.`,
      "success"
    );
    onClose();
    return;
  }
    const newErrors = {};
    console.log(typeof categoryList);

    if (!dishName.trim()) {
      newErrors.dishName = "Dish name is required.";
    } else if (/\s{2,}/.test(dishName)) {
      newErrors.dishName = "Dish name can't contain multiple spaces.";
    }
    if (!category && !isNewCategory)
      newErrors.category = "Category is required.";
    if (!price) newErrors.dishPrice = "Price is required.";
    if (
      isNewCategory &&
      Object.values(categoryList).some(
        (category) =>
          typeof category === "string" &&
          category.toLowerCase() === addNewCategory.toLowerCase()
      )
    ) {
      newErrors.addNewCatageory = "category is already exist.";
    }
    // Validate dish image (required, exactly 1)
    if (images.length === 0) {
      newErrors.dishImage = "Dish image is required.";
    } else if (images.length > 1) {
      newErrors.dishImage = "Only 1 dish image is allowed.";
    }
    if (isNewCategory && !addNewCategory.trim())
      newErrors.addNewCatageory = "category is required.";
    if (/\s{2,}/.test(addNewCategory)) {
      newErrors.addNewCatageory = "category can't contains multiple spaces.";
    }

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      return;
    }

    onSave({
      dishName,
      category,
      price,
      images: images.map((img) => img.key),
      isVeg,
      dishDetails,
      addNewCategory,
      dishDescription,
    });
    onClose();
  };

  const handleBlur = (field) => {
    setError((prevState) => ({ ...prevState, [field]: "" }));
  };

  const handleOnClose = async () => {
    // Remove newly uploaded images from S3 when closing without saving
    const s3KeysToRemove = images.filter(img => img.key && !img.isExisting).map(img => img.key);
    if (s3KeysToRemove.length > 0) {
      await removeDishImagesFromS3(s3KeysToRemove);
    }
    
    // Clean up object URLs
    images.forEach(img => {
      if (img.preview && img.preview.startsWith('blob:')) {
        URL.revokeObjectURL(img.preview);
      }
    });
    
    onClose();
  };

  return (
    isOpen && (
      <div className="edit-modal-overlay">
        <div className="edit-modal">
          <div className="edit-modal-header">
            <span>Edit Details</span>
            <button onClick={handleOnClose} className="close-button">
              <img src={cross} alt="cross" />
            </button>
          </div>
          <div className="edit-modal-body">
            <div className={`input-group ${error.dishName ? "error" : ""}`}>
              <label>Dish Name <span style={{color: 'red'}}>*</span></label>
              <input
                type="text"
                value={dishName}
                onChange={handleDishNameChange}
                onKeyDown={handleDishNameKeyDown}
                maxLength={42}
                placeholder="Type here"
                onBlur={() => handleBlur("dishName")}
                className={error.dishName ? "input-error" : ""}
              />
              {error.dishName && (
                <span className="error-message">{error.dishName}</span>
              )}
            </div>

            <div className={`input-group ${error.category ? "error" : ""}`}>
              <label>Choose Category <span style={{color: 'red'}}>*</span></label>
              <select
                value={category}
                onBlur={() => handleBlur("category")}
                onChange={handleSelectCategoryChange}
                className={error.category ? "input-error" : ""}
              >
                <option value="" disabled>
                  Select category
                </option>
                {categoryList.map((cat, index) => (
                  <option key={index} value={cat}>
                    {cat}
                  </option>
                ))}
                <option value="Others">Others</option>
              </select>
              {error.category && (
                <span className="error-message">{error.category}</span>
              )}
            </div>
            {isNewCategory && (
              <div
                className={`input-group ${
                  error.addNewCatageory ? "error" : ""
                }`}
              >
                <label>New Category <span style={{color: 'red'}}>*</span></label>
                <input
                  type="text"
                  value={addNewCategory}
                  onBlur={() => handleBlur("addNewCatageory")}
                  onChange={handleCategoryChange}
                  onKeyDown={handleCategoryKeyDown}
                  placeholder="Enter new category"
                  maxLength={42}
                />
                {error.addNewCatageory && (
                  <span className="error-message">{error.addNewCatageory}</span>
                )}
              </div>
            )}
            <div className="veg-nonveg-toggle">
              <div className="toggle-container">
                <button
                  type="button"
                  className={isVeg ? "active veg-button" : "veg-button"}
                  onClick={() => handleVegToggle(true)}
                >
                  <img src={Veg} alt="veg" />
                  Veg
                </button>
                <button
                  type="button"
                  className={!isVeg ? "active nonveg-button" : "nonveg-button"}
                  onClick={() => handleVegToggle(false)}
                >
                  <img src={NonVeg} alt="nonveg" />
                  Non-Veg
                </button>
              </div>
            </div>

            <div className={`input-group ${error.dishDescription ? "error" : ""}`}>
              <label>Dish Description</label>
              <input
                value={dishDescription}
                onChange={(e) => setDishDescription(e.target.value)}
                placeholder="Enter dish description"
                maxLength={100}
                rows={3}
                onBlur={() => handleBlur("dishDescription")}
                className={error.dishDescription ? "input-error" : ""}
              />
              {error.dishDescription && (
                <span className="error-message">{error.dishDescription}</span>
              )}
            </div>

            <div className={`input-group ${error.dishImage ? "error" : ""}`}>
              <label>Dish Image <span style={{color: 'red'}}>*</span></label>
              <div className="image-preview-container">
                {images.map((img, index) => (
                  <div key={index} className="image-preview">
                    <img src={img.preview} alt={`Preview ${index}`} />
                    <button
                      type="button"
                      className="remove-image-button"
                      onClick={() => handleRemoveImage(index)}
                    >
                      ×
                    </button>
                  </div>
                ))}
                {images.length < 1 && (
                  <div className="add-image" onClick={handleClickAddImage}>
                    <span>+</span>
                  </div>
                )}
              </div>
              {error.dishImage && (
                <span className="error-message">{error.dishImage}</span>
              )}
            </div>
          <input
            type="file"
            ref={fileInputRef}
            accept="image/*"
            onChange={handleImageUpload}
            style={{ display: "none" }}
          />

          <div className={`input-group ${error.dishPrice ? "error" : ""}`}>
              <label>Set Price <span style={{color: 'red'}}>*</span></label>
              <input
                type="text"
                value={price}
                onChange={handleSetPriceChange}
                placeholder="Type here"
                onBlur={() => handleBlur("dishPrice")}
                className={error.dishPrice ? "input-error" : ""}
              />
              {error.dishPrice && (
                <span className="error-message">{error.dishPrice}</span>
              )}
            </div>
          </div>
          <div className="edit-modal-footer">
            <button onClick={handleSave} className="save-button">
              Save Details
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default EditModal;

